/* Component Dependencies */
var erfpAddressInfoTemplate = require('templates/erfpAddressInfo.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');
var $ = require('jquery');

AriesComponent.create({
  type: 'erfpAddressInfo',
  template: {
    'erfpAddressInfo': erfpAddressInfoTemplate
  },
  formData : {
    addressFormData : {}
  },
  addressInfo : {},
  config : {
    prefferedAddressBusinessCode : 'B'
  },
  events: {
    'change .js-address-type-radio' : 'selectAddressType',
    'blur input[type="text"]': 'publishAddressToSummary'
  },
  bindEvents: function(jquery) {
    var _self = this,
    $stateDropdown = _self.$el.find('.js-select-state'),
    $countryDropDown = _self.$el.find('.js-select-country');
    _self.$ = jquery;
    _self.$($countryDropDown).on('change', _.bind(_self.countryOnChangeRule, _self));
    _self.$($stateDropdown).on('change', _.bind(_self.updateSelectedState, _self));

    /* fill json object with pre populated values in case of signed in user*/
    this.$el.find('input').each(function() {
      _self.fetchData($(this)[0]);
    });
    _self.addressInfo[$countryDropDown[0].name] = _self.$el.find('.js-select-country option:selected').val();
    if($stateDropdown.length) {
      var stateDropDownValue = $stateDropdown[0].value;

      _self.addressInfo['stateProvince'] = stateDropDownValue;
      _self.addressInfo['stateDescription'] = this.setStateDescription(stateDropDownValue);
    }
    $(document).ready(function() {
			_self.pubsub.publish('UPDATE_FORM_DATA', ['eventAddressDetails', _self.addressInfo]);
		});

  },
    /**
   * Change field types based on country selection.
   * @param {event} event - Event object
   */
  countryOnChangeRule : function _countryOnChangeRule(event){
    var _self = this,
    $currentElement = $(event.target),
    currentElement = event.currentTarget,
    elementName = currentElement.name,
    selectedCounty = $currentElement.val();
    _self.addressInfo[elementName] = selectedCounty;
    _self.refreshAddressForm(selectedCounty);
  },
  /**
   * @method setStateDescription
   * Based on the selected stateProvince code, sets the stateProvince label in a hidden field.
   * @param {String} stateProvince - selected stateProvince code
   * @returns {String} returns stateProvince label for the supplied stateProvince code.
   */
  setStateDescription: function (stateProvince) {
    var _self = this,
    $stateDropdown = _self.$el.find('.js-select-state'),
    stateDescription = '';

    if ($stateDropdown.length) {
      /* If stateProvince dropdown exists, stateDescription should be label of the selected state option.*/
      if (stateProvince) {
        stateDescription = _self.$el.find('.js-select-state option:selected').text();
      }
    } else {
      /* If stateProvince input exists, stateDescription should be same as the stateProvince (input from User)*/
      stateDescription = stateProvince;
    }
    _self.$el.find('#stateDescriptionHiddenTxt').val(stateDescription);

    return stateDescription;
  },
  /**
   * Toggle business name textfield enable or disable
   * @param {event} event - Event object
   */
  selectAddressType : function _selectAddressType(event) {
    var _self = this,
    $currentElement = $(event.target),
    currentElement = event.currentTarget,
    elementValue = event.currentTarget.value,
    $companyNameElement = _self.$el.find('.js-company-name');
    if ($currentElement.val().toUpperCase() === _self.config.prefferedAddressBusinessCode) {
      $companyNameElement.removeClass('l-disabled-error').removeAttr('disabled');
    } else {
      $companyNameElement.addClass('l-disabled-error').attr('disabled', 'disabled').val('');
    }

    this.fetchData(currentElement);
    this.sendAddressData();

  },
  /**
   * Refresh Address form and get new form configuration based on selected country
   * @param {string} country code string as parameter.
   */
  refreshAddressForm : function _refreshAddressForm(countryCode) {
    var _self = this,
    context={};
    _self.saveAddressFormData();

    context = {
      countryCode : countryCode,
      addressType : _self.formData.addressFormData.addressType
    };
    _self.refresh(context, function () {
      _self.$(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-select');
      _self.populateAddressFormData();
      _self.$el.find('input').each(function() {
       _self.fetchData($(this)[0]);
      });
      _self.sendAddressData();
      _self.pubsub.publish('JOINNOW_FORM_REFRESH', [{
        type: 'countryChange',
        context: context
      }]);
    });
  },
  /**
   * Save address form data before refreshing the tile
   */
  saveAddressFormData: function _saveAddressFormData() {
    var _self = this,
    stateProvince = _self.$el.find('#state').val(),
    stateDescription = _self.setStateDescription(stateProvince);

    _self.formData.addressFormData = {
        'addressType' : _self.$el.find('[name="addressTypeRadio"]:checked').val(),
        'companyName' : _self.$el.find('#company-name').val(),
        'addressLine1': _self.$el.find('#address-line1').val(),
        'addressLine2': _self.$el.find('#address-line2').val(),
        'city': _self.$el.find('#city').val(),
        'state': stateProvince,
        'stateDescription': stateDescription,
        'postalCode': _self.$el.find('#postal-code').val()
    };
  },
  /**
   * Populate all the address fomr data after refresh of tile.
   */
  populateAddressFormData : function _populateAddressFormData () {
    var _self = this;
    _self.$el.find('#company-name').val(_self.formData.addressFormData.companyName),
    _self.$el.find('#address-line1').val(_self.formData.addressFormData.addressLine1);
    _self.$el.find('#address-line2').val(_self.formData.addressFormData.addressLine2);
    _self.$el.find('#city').val(_self.formData.addressFormData.city);
    _self.$el.find('#state').val(_self.formData.addressFormData.state);
    _self.$el.find('#stateDescriptionHiddenTxt').val(_self.formData.addressFormData.stateDescription);
    _self.$el.find('#postal-code').val(_self.formData.addressFormData.postalCode);
  },
  publishAddressToSummary: function(event) {
    var _self = this,
    currentElement = event.currentTarget,
    elementName = currentElement.name,
    elementValue = currentElement.value;

    this.fetchData(currentElement);
    this.sendAddressData();
  },
  updateSelectedState: function(event){
    var $currentElement = $(event.currentTarget),
    elementValue = $currentElement.val(),
    stateDescription = this.setStateDescription(elementValue);

    this.addressInfo['stateProvince'] = elementValue;
    this.addressInfo['stateDescription'] = stateDescription;

    this.sendAddressData();
  },
  fetchData: function(currentElement) {
    var elementValue = currentElement.value,
    elementName = currentElement.name,
    elementType = currentElement.type;

    switch(elementType) {
      case 'text':
      if(elementName === 'state') {
        this.addressInfo['stateProvince'] = elementValue;
        this.addressInfo['stateDescription'] = this.setStateDescription(elementValue);
      }
      else {
        this.addressInfo[elementName] = elementValue;
      }
      break;

      case 'radio':
      if(currentElement.checked) {
        if(elementValue === 'P') {
          this.addressInfo['homeAddressSelected'] = true;
          this.addressInfo['businessAddressSelected'] = false;
        }
        else if(elementValue === 'B') {
          this.addressInfo['homeAddressSelected'] = false;
          this.addressInfo['businessAddressSelected'] = true;
        }
      }
      break;
    }
  },
  sendAddressData: function() {
    this.pubsub.publish('UPDATE_EVENT_SUMMARY',['addressInformation',this.addressInfo]);
  }
});
